import { FormFieldContainer, FormFields2ColContainer } from 'components/form-fields/shared-style'
import React from 'react'
import { formFieldNames } from '.'
import TextInput from 'components/form-fields/input'
import { StyledHeading, StyledPageHeader, StyledParagraph, StyledProcessText } from './style'
import { useFormContext } from 'react-hook-form'
import { translate } from 'locales/i18n'

const FormStep5: React.FC = () => {
  const { watch } = useFormContext()

  const watchCurrentStep = watch(formFieldNames.CURRENT_STEP)

  return (
    <div>
    <StyledPageHeader>
      <div>
        <StyledHeading>{translate('forms.step5.heading')}</StyledHeading>
      </div>
      <StyledProcessText>{translate('forms.steps', { watchCurrentStep })}</StyledProcessText>
    </StyledPageHeader>
    <StyledParagraph>{translate('forms.step5.paragraph')}</StyledParagraph>
  <FormFieldContainer>
    <TextInput
    required
        name={formFieldNames.ORGANIZATION_NAME}
        label={translate('forms.newLead.organisation')}
        placeholder={translate('forms.newLead.organisation')}
      />
  </FormFieldContainer>
  <FormFieldContainer>
    <TextInput
    required
        name={formFieldNames.PERSON_NAME}
        label={translate('forms.newLead.name')}
        placeholder={translate('forms.newLead.name')}
      />
  </FormFieldContainer>
  <FormFields2ColContainer>
    <TextInput
    required
        name={formFieldNames.PERSON_EMAIL}
        label={translate('forms.newLead.email')}
        placeholder={translate('forms.newLead.email')}
      />
      <TextInput
        name={formFieldNames.PERSON_PHONE}
        label={translate('forms.newLead.phone')}
        placeholder={translate('forms.newLead.phone')}
      />
  </FormFields2ColContainer>
</div>

  )
}

export default FormStep5
